// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../global/assets/Header 11.12.42.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, "._3VOf_{background:#fff;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-repeat:no-repeat;background-position:100% 0;padding:80px 0;background-size:100%}._1Gh9b ._38Bd1,[data-theme=compact] ._1Gh9b ._38Bd1{margin-bottom:12px;overflow:hidden;background:#f1f1f1;border-radius:10px}", ""]);
// Exports
exports.locals = {
	"header": "_3VOf_",
	"sitecollapse": "_1Gh9b",
	"sitepanel": "_38Bd1"
};
module.exports = exports;
